import React, {useState, useEffect} from 'react';
import Dropzone from 'react-dropzone';
import ReactS3Client from 'react-aws-s3-typescript';
import firebase from '../firebase';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import 'firebase/database';
import {useListVals} from 'react-firebase-hooks/database';

const rTimeDbase = firebase.database();

//TO DO - Change the state functions to arrays to support multiple cards


function UploadCardsView() {
    const [frontPics, setFrontPics] = useState<File[]>([]);
    const [backPics, setBackPics] = useState<File[]>([]);
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState(0);
    const [firm, setFirm] = useState(false);
    const [url, setURL] = useState([]);
    const [numCards, setNumCards] = useState(0);
    const [modalDescription, setModalDescription] = useState('');
    const [modalPrice, setModalPrice] = useState(0);
    const [modalFirm, setModalFirm] = useState(false);
    const [modalCard, setModalCard] = useState(null);
    const [modalID, setModalID] = useState(-1);
    const [modalURL, setModalURL] = useState('');

    const cardsRef = rTimeDbase.ref('cards/');
    const [snapshots, loading, error] = useListVals(cardsRef);


    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    

  
    function onDropFront(acceptedFiles: File[]){
       setFrontPics(acceptedFiles.map(file => 
        Object.assign(file, { preview: URL.createObjectURL(file)} )
        
        ));


      //files are here

     
  
  
    }
  
    function onDropBack(acceptedFiles: File[]){
      setBackPics(acceptedFiles.map(file => Object.assign(file, {
       preview: URL.createObjectURL(file)
     })));
  
  
   }
  
   useEffect(() =>{

    //happens after render? 
    //console.log('trigger', url.length, frontPics.length)
  
    if(url.length === frontPics.length && url.length !== 0){



      for (var i=0; i < url.length; i++){

        var id: number;
        if (snapshots){
          if(snapshots.length > 0){
            id = snapshots.length + i;
          }else{
            id = i;
          }
        }else{
          console.log('snapshots undefined');
          id = -1;
        }

        console.log("id", id);
        const card = {
          description: description,
          price: price,
          firm: firm,
          url: url[i],
          id: id
        }

        


        var database = firebase.database().ref('cards/' + id);
        database.set(card);
        
      }
      setFrontPics([]);
      setURL([]);
    }
  
  
   }, [description, price, firm, url, frontPics,numCards]);
  
   function SubmitCard(e: React.SyntheticEvent){
     e.preventDefault();
     // want to send to firebase as a "card"
     // maybe need to upload picture first and then can send to firebase with a URL to image
     
  
     URL.createObjectURL(frontPics[0]);



 
  
      uploadFile().then((res) =>{
          setURL(res);
          setDescription('');
          setFirm(false);
          setPrice(0);
       

        })

     



     //for multiple cards need to save multiple URLS
    
  
     
     //ToDo: .heic files wont preview, horizontal cards? gonna need a bigger space or something. or possibly rotate it
  

  
  
     //setFrontPics([]);
  
  
     
   }

   function updateCard(card: any){
    setModalDescription(card.description);
    setModalPrice(card.price);
    setModalFirm(card.firm);
    setModalCard(card);
    setModalID(card.id);
    setModalURL(card.url);
    handleShow();
   }

   function modalSubmit(e: React.SyntheticEvent){
     e.preventDefault();
     //console.log('update card', modalCard);

    // console.log(modalDescription, modalPrice, modalFirm, modalID);

   

    const card = {
      description: modalDescription,
      price: modalPrice,
      firm: modalFirm,
      url: modalURL,
      id: modalID,
    }

    


    var database = firebase.database().ref('cards/' + modalID);
    database.set(card);

    handleClose();
   }
  
   async function uploadFile(){
     const s3 = new ReactS3Client(
       {
         bucketName: 'pogoz',
         region: 'us-west-1',
         accessKeyId: 'AKIAWTF6LCMRT2BTMLY5',
         secretAccessKey: '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'
       }
     );
  
       //to do try loop in here

     try{

      let urlArr: any = [];
      for(var i=0; i < frontPics.length; i++){
        const res = await s3.uploadFile(frontPics[i]);
        console.log('success ', res);
        urlArr.push(res.location);
      }




      return urlArr;
  
     } catch (exception){
       console.log(exception);
       return 'fail';
     }
   }
  
    const thumbsContainer: any = {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    };
     
    const thumb: any = {
      display: 'inline-flex',
      height: 300,
      marginTop: '-15px',
    };
     
    const thumbInner = {
      display: 'flex',
    };
     
    const img = {
      display: 'block',
      width: 'auto',
      height: '100%'
    };
     
  
    const front = frontPics.map((file: any) => (
      <div style={thumb} key={file.name}>
        <div style={thumbInner} >
          <img
            alt={file.name}
            src={file.preview}
            style={img}
          />
        </div>
      </div>
    ));
  
    const back = backPics.map((file: any) => (
      <div style={thumb} key={file.name}>
        <div style={thumbInner} >
          <img
            alt={file.name}
            src={file.preview}
            style={img}
          />
        </div>
      </div>
    ));
  
    
  
    return (
      <div className="container">        
        <form onSubmit={SubmitCard}>
          <div className="row">
            <div className="col-3">
            <Dropzone    
                onDrop={onDropFront}
                accept="image/*"
              >
                {({getRootProps, getInputProps}) => (
                  
                    <div className='dropzone' {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p>Front</p>
                      <div style={thumbsContainer}>
                      {front}
                      </div>
                    
                    </div>
                    
              
                )}
              </Dropzone>
  
  
            </div>
            <div className="col-3" >
            <Dropzone 
                onDrop={onDropBack}
                accept="image/*"
              >
                {({getRootProps, getInputProps}) => (
                    <div className='dropzone' {...getRootProps()}>
                      <input {...getInputProps()} />
                      <p>Back (Optional)</p>
                      <div style={thumbsContainer}>
                        {back}
                      </div>
                    </div>
                )}
              </Dropzone>
  
  
            </div>
            <div className="col-6" >
              <div style={{marginTop: '10px'}}></div>
  
              <div className="form-row">
                <label>Description:</label>
                <input type='text' className='form-control entry' value={description} onChange={e => setDescription(e.target.value)}></input>
  
                <div className="form-group col-6">
                <label>Price:</label>
                <input type='number' step="0.1" className='form-control entry' value={price} onChange={e => setPrice(parseFloat(e.target.value))}></input>
                </div>
  
                <div className="form-group col-6">
                  <div className="form-check">
                    <input type='checkbox' className='form-check-input' checked={firm} onChange={() => setFirm(!firm)}></input>
                    <label>Firm</label>
                  </div>
  
                </div>
  
                <div  style={{display: 'flex', flexDirection: 'row', overflowX: 'scroll',backgroundColor: 'white', borderStyle: 'solid', height: '200px', width: '600px'}}>
                  {snapshots && snapshots.map((card: any, id: number) => <div key={id} onClick={() => updateCard(card)}> <img alt="" width="140" src={card.url}/> </div>)}
                </div>
                
     
              </div>
  
            </div>
          </div>
          <div className="row">
         
            <div className='col-12 text-center'>
            <div style={{marginTop: '10px'}}></div>
              <button type="submit" className="btn btn-primary">Submit</button>
  
            </div>
          </div>
          </form>

          <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Card</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={modalSubmit}>
            <div className="form-row">
              <label>Description:</label>
              <input type='text' className='form-control entry' value={modalDescription} onChange={e => setModalDescription(e.target.value)}></input>
            </div>

            <div className="form-group col-6">
              <label>Price:</label>
              <input type='number' step='0.1' className='form-control entry' value={modalPrice} onChange={e => setModalPrice(parseFloat(e.target.value))}></input>
              
            </div>

            
            <div className="form-check col-6">
                    <input type='checkbox' className='form-check-input' checked={modalFirm} onChange={() => setModalFirm(!modalFirm)}></input>
                    <label>Firm</label>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>
      </div>
    );
  }

  export default UploadCardsView;